import React from 'react';
import Button from '@mui/material/Button';

import 'components/RequestPasswordForm/RequestPasswordForm.css';
import CustomerIdInput from 'components/UI/Input/CustomerIdInput';
import { Form, useActionData } from 'react-router-dom';
import EmailInput from 'components/UI/Input/EmailInput';
import { requestPassword } from 'lib/request-password-api';
import { Alert, Typography } from '@mui/material';
import T from 'i18n-react';

const RequestPasswordForm = ({ submitting }) => {

  const success = useActionData();

  const error = success === undefined ? false : !success;

  if (success) {
    return (<>
      <Typography className='emailSentText' variant={'h6'} component={'h6'}>{T.translate('resetPasswordComponent.successMessage')}</Typography>
      <Typography variant={'body1'} component={'p'}>{T.translate('resetPasswordComponent.successMessageDetails')}</Typography>
    </>);
  }

  return (
    <Form className="form" method={'post'} action={'/request-password'}>
      <CustomerIdInput isError={error} />
      <EmailInput isError={error} />
      {error &&
        <Alert variant="filled" severity="error">
          {T.translate('resetPasswordComponent.failMessage')}
        </Alert>
      }
      <Button
        className='passwordFormSubmitButton'
        disabled={submitting}
        variant={'contained'}
        type={'submit'}
      >{T.translate("recoverPasswordComponent.requestPassword")}</Button>
    </Form>
  );
};

export default RequestPasswordForm;

export const action = async ({ request }) => {
  const formData = await request.formData();
  const customerId = formData.get('customerId');
  const email = formData.get('email');
  return await requestPassword(customerId, email);
};
